







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { app } from '@src/store/modules/app';
import { displayAccountType } from '@src/utils/investment-entity';
import { investmentEntity } from '@src/store/modules/investment-entity';
import { InvestmentEntity } from 'types/investment-entity';
import { user } from '@src/store/modules/user';

@Component
export default class NavInvestmentEntityListItem extends Vue {
	@Prop()
	entity!: InvestmentEntity;

	displayAccountType = displayAccountType;

	async changeInvestmentEntity(investmentEntityId: string) {
		try {
			if (app.isCorniceSubstituteUser) {
				await user.updateSelectedEntityWithoutReload({
					investmentEntityId,
					nextRoute: { route: { name: 'profile-investment-accounts-view' } }
				});
			} else {
				await user.updateSelectedEntity(investmentEntityId);
			}
		} catch {
			app.ADD_TOAST({
				type: 'error',
				message: 'We are unable to switch your account at this time. Please try again later.'
			});
		}
	}

	get isDesktop(): boolean {
		return app.screenSize === 'DESKTOP';
	}

	get selectedInvestmentEntityId(): string {
		return investmentEntity.investmentEntityId;
	}

	get isActiveEntity(): boolean {
		return this.entity.investmentEntityId === this.selectedInvestmentEntityId;
	}

	get accountType(): string {
		if (this.entity.isIraEntity) {
			if (this.entity.iraEntityMetadata.iraTypeLabel) {
				return this.entity.iraEntityMetadata.iraTypeLabel + ' IRA';
			}
			return 'Undesignated IRA';
		}
		return this.entity.entityTypeLabel ?? '';
	}
}
